 import React, { useEffect, useState } from "react";
import { getApprovedFeedback } from "../services/feedbackService";
import "./ApprovedFeedback.css"

const ApprovedFeedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchApprovedFeedback();
  }, []);

  const fetchApprovedFeedback = async () => {
    try {
      const data = await getApprovedFeedback();
      setFeedbacks(data || []);
    } catch (error) {
      console.error("Error fetching approved feedback:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading feedback...</p>;
  }

  if (feedbacks.length === 0) {
    return (
      <p style={{ textAlign: "center" }}>
        No approved feedback available.
      </p>
    );
  }

  return (
    <div className="approved-feedback-section">
      <h2 className="approved-feedback-title">
        What Our Users Say
      </h2>

      <div className="feedback-grid">
        {feedbacks.map((fb) => (
          <div key={fb._id} className="feedback-card-item">
            <h3>{fb.name}</h3>
            <p>{"⭐".repeat(fb.rating)}</p>
            <p>"{fb.description}"</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApprovedFeedback;